import React from 'react';
import styled from 'styled-components';
import { variables } from '../../../styles/variables';

interface Props {
  opened: boolean;
  [key: string]: unknown;
}

export const Aside = styled(({ opened, ...props }: Props) => <aside {...props} />)`
  z-index: 1;
  display: flex;
  background: ${variables.colorWhite};
  transform: ${({ opened }) => (opened ? 'translateX(0)' : 'translateX(-110%)')};
  height: calc(100% + 30px);
  position: absolute;
  left: 0;
  transition: transform 0.5s ease-in-out;
  overflow-y: auto;
  padding: 10px;
  width: 100%;
  min-height: 250px;
  @media (min-width: 568px) {
    & > div > div {
      flex-direction: column-reverse;
    }
  }
  @media (max-width: 567px) {
    flex-direction: column;
  }
`;
